import React from 'react';
import PropTypes from 'prop-types';

import './index.scss';

const WalletBalanceCard = ({ children, onClick, className = '' }) => {
  const handleWalletCardClick = event => {
    if (typeof onClick === 'function') onClick(event);
  };

  const handleKeyDown = event => {
    if (!event || typeof event.preventDefault !== 'function') return;
    event.preventDefault();
  };
  return (
    <div
      aria-label="button"
      role="button"
      tabIndex={0}
      onKeyDown={handleKeyDown}
      onClick={handleWalletCardClick}
      className={`wallet-balance-card ${className}`}
    >
      {children}
    </div>
  );
};

const Title = ({ children, className = '' }) => (
  <span className={`wallet-balance-card__label ${className}`}>{children}</span>
);

const Amount = ({ children, className = '' }) => (
  <h2 className={`wallet-balance-card__amount ${className}`}>{children}</h2>
);

const Value = ({ children, className = '' }) => (
  <span className={className}>{children}</span>
);
const Currency = ({ currency = '₹', className = '' }) => (
  <span className={`wallet-balance-card__currency ${className}`}>
    {currency}
  </span>
);

const Footer = ({ children, className = '' }) => (
  <div className={`wallet-balance-card__footer ${className}`}>{children}</div>
);

const IconWrapper = ({ children, className = '' }) => (
  <div className={`wallet-balance-card__icon ${className}`}>{children}</div>
);

WalletBalanceCard.Content = ({ children, className }) => (
  <div className={`wallet-balance-card__content ${className}`}>{children}</div>
);

WalletBalanceCard.Content.Title = Title;
WalletBalanceCard.Content.Amount = Amount;
WalletBalanceCard.Content.Amount.Value = Value;
WalletBalanceCard.Content.Amount.Currency = Currency;
WalletBalanceCard.Content.Footer = Footer;
WalletBalanceCard.IconWrapper = IconWrapper;

WalletBalanceCard.propTypes = {
  className: PropTypes.string
};

export default WalletBalanceCard;
